// "My RAG Can Answer 'Who Calls This Function?'" — graph_query / code-intelligence short.
// Cold Compute / Neon kit. ~127s @ 30fps. Mirrors hybrid-search-vector-bm25 structure.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous, no gaps.
// Each scene duration ≈ round((lastCaption.fromSec + ~6) * 30) so the last caption
// (sticky → holds to scene end) gets ~6s of read time and never cuts off.
export const SCENE = {
  hook: { start: 0, duration: 360 }, //         0:00–0:12  the question vector search can't answer
  problem: { start: 360, duration: 360 }, //    0:12–0:24  edges, not embeddings
  intuition: { start: 720, duration: 360 }, //  0:24–0:36  the graph already lives in metadata_graph
  approach: { start: 1080, duration: 570 }, //  0:36–0:55  classify → translate → traverse → cite
  tool: { start: 1650, duration: 570 }, //      0:55–1:14  graph_query: 5 ops, tenant-isolated
  honesty: { start: 2220, duration: 570 }, //   1:14–1:33  jsonb not graph DB; AGE rejected; RAG fallback
  payoff: { start: 2790, duration: 360 }, //    1:33–1:45  deterministic, no LLM, p95 <4s
  outro: { start: 3150, duration: 330 }, //     1:45–1:56
} as const;

export const TOTAL_DURATION =
  SCENE.hook.duration +
  SCENE.problem.duration +
  SCENE.intuition.duration +
  SCENE.approach.duration +
  SCENE.tool.duration +
  SCENE.honesty.duration +
  SCENE.payoff.duration +
  SCENE.outro.duration; // 3480 frames = 116s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
